/* eslint-disable*/
import React, { useEffect, useState } from 'react';
import { DefaultTable } from 'src/components';
import { useActions } from 'src/hooks/useActions';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { IPayStatement } from 'src/interfaces';
import PaymentsService from 'src/services/payments.service';

const columns = [
  {
    name: 'Check Date',
    selector: (row: any) => row.checkDate,
  },
  {
    name: 'Control Code',
    selector: (row: any) => row.controlCode,
  },
  {
    name: 'Net Wages',
    selector: (row: any) => row.netWages,
  },
  {
    name: 'Gross Wages',
    selector: (row: any) => row.grossWages,
  },
  {
    name: 'Pay Statement Number',
    selector: (row: any) => row.payStatementNumber,
  },
  {
    name: 'Link',
    button: true,
    cell: (row: any) => (
      <a
        href={PaymentsService.getPayStubPdf({
          ptn: row.payStatementNumber || '',
          companyId: useTypedSelector(state => state.config.data?.config?.selectedCompanyId) || '',
          employeeId: useTypedSelector(state => state.employees.data?.selectedEmployee.employee?.id) || '',
          downloadFile: true,
        })}
        target="_blank"
        rel="noopener noreferrer"
      >
        Download
      </a>
    ),
  },
  {
    name: 'Detailed Link',
    button: true,
    cell: (row: any) => (
      <a
        href={PaymentsService.getDetailedPayStubPdf({
          ptn: row.payStatementNumber || '',
          companyId: useTypedSelector(state => state.config.data?.config?.selectedCompanyId) || '',
          employeeId: useTypedSelector(state => state.employees.data?.selectedEmployee.employee?.id) || '',
          downloadFile: true,
        })}
        target="_blank"
        rel="noopener noreferrer"
      >
        Download
      </a>
    ),
  },
];

export const EmployeePayStatementsTable: React.FC<{
  handleChange: (selected: { allSelected: boolean; selectedCount: number; selectedRows: IPayStatement[] }) => void;
}> = ({ handleChange }) => {
  const { selectedEmployee } = useTypedSelector(state => state.employees.data);
  const { loading } = useTypedSelector(state => state.employees);
  const { config } = useTypedSelector(state => state.config.data);
  const { getEmployeePayStatements } = useActions();
  const [data, setData] = useState<IPayStatement[]>([]);
  const [totalRows, setTotalRows] = useState(0);
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    setData(selectedEmployee.payStatements || []);
    setTotalRows(selectedEmployee.totalPayStatements || 0);
  }, [selectedEmployee.payStatements]);

  const fetchPayStatements = async (page: number) => {
    const companyId = config?.selectedCompanyId || '';
    const employeeId = selectedEmployee.employee?.id || '';
    getEmployeePayStatements({ page, companyId, limit, employeeId });
  };

  useEffect(() => {
    if (config?.selectedCompanyId) fetchPayStatements(1);
  }, [config?.selectedCompanyId]);

  const handlePageChange = (page: number) => {
    fetchPayStatements(page);
  };

  const handlePerRowsChange = async (newLimit: number, page: number) => {
    const companyId = config?.selectedCompanyId || '';
    const employeeId = selectedEmployee.employee?.id || '';
    getEmployeePayStatements({ page, companyId, limit: newLimit, employeeId });
    setLimit(newLimit);
  };

  return (
    <DefaultTable
      columns={columns}
      data={data}
      progressPending={loading}
      pagination
      paginationServer
      paginationTotalRows={totalRows}
      onChangeRowsPerPage={handlePerRowsChange}
      onChangePage={handlePageChange}
      onSelectedRowsChange={handleChange}
      selectableRows
    />
  );
};
